<div [ngClass]="{ 'row-reverse': reverse() }">
  <span class="label">{{ label() ?? '' }}</span> <span class="value">{{ value() ?? '' }}</span>
</div>
